module.exports = __webpack_public_path__ + "img/energyImg1.f30c0776.png";